import { ActivateUserPayload, UserStatus } from '@dev/ee-api/ee-api-models';
import { ActionCreator } from 'redux';

import * as Types from './types';

const { ActionTypes } = Types;

export const ActivateUser: ActionCreator<Types.ActivateUsersAction> = (activateUserParams: ActivateUserPayload) => ({
    type: ActionTypes.ACTIVATE_USER,
    payload: activateUserParams,
    meta: {
        thunk: true,
    },
});

export const ActivateUserStart: ActionCreator<Types.ActivateUsersStartAction> = () => ({
    type: ActionTypes.ACTIVATE_USER_START,
});

export const ActivateUserSuccess: ActionCreator<Types.ActivateUsersSuccessAction> = (
    meta: Record<string, unknown>
): Types.ActivateUsersSuccessAction => ({
    type: ActionTypes.ACTIVATE_USER_SUCCESS,
    meta,
});

export const ActivateUserError: ActionCreator<Types.ActivateUsersErrorAction> = (
    error: Record<string, unknown>,
    meta: Record<string, unknown>
): Types.ActivateUsersErrorAction => ({
    type: ActionTypes.ACTIVATE_USER_ERROR,
    payload: {
        ...error,
    },
    meta,
    error: true,
});

export const CheckIfUserIsActivated: ActionCreator<Types.CheckIfUserIsActivatedAction> = (
    username: string,
    verificationCode: string
): Types.CheckIfUserIsActivatedAction => ({
    type: ActionTypes.CHECK_USER_REGISTRATION,
    payload: {
        username,
        verificationCode,
    },
});

export const CheckIfUserIsActivatedStart: ActionCreator<Types.CheckIfUserIsActivatedStartAction> = (
    username: string,
    verificationCode: string
): Types.CheckIfUserIsActivatedStartAction => ({
    type: ActionTypes.CHECK_USER_REGISTRATION_START,
    payload: {
        username,
        verificationCode,
    },
});

export const CheckIfUserIsActivatedSuccess: ActionCreator<Types.CheckIfUserIsActivatedSuccessAction> = (
    userStatusParams: UserStatus
): Types.CheckIfUserIsActivatedSuccessAction => ({
    type: ActionTypes.CHECK_USER_REGISTRATION_SUCCESS,
    payload: userStatusParams,
});

export const CheckIfUserIsActivatedError: ActionCreator<Types.CheckIfUserIsActivatedErrorAction> = (
    errorMessage?: string
): Types.CheckIfUserIsActivatedErrorAction => ({
    type: ActionTypes.CHECK_USER_REGISTRATION_ERROR,
    payload: {
        errorMessage,
    },
});
